<template>
<div class=" mt-3 col-12 d-flex flex-column align-items-center">
  <div class="col-12 mt-3  d-flex flex-column align-items-center">
    <label for=""><b>Belastingspercentage</b></label>
    <v-select v-if="false"
      class="style-chooser mt-2 belastingspercentage__dropdown"
      v-model="belastingsPercentage"
      placeholder="Kies een belastingspercentage"
      
      @input="() => {setBelastingsPercentage(belastingsPercentage)}"
      label="label"
      :options="belastingsPercentageList"
    >
      <template #selected-option="{ percentageLabel }">
        <div style="display: flex; align-items: baseline">
          {{ percentageLabel }}
        </div>
      </template>
    </v-select>
    <div class="wtr__switch--v">
        <div class="wtr__switch__top" @click="setBelastingsPercentage(37.07)" :class="(belastingsPercentage === 37.07) ? 'wtr__switch--active':''"><b>37,07% (Belastbaar  tot € 69.398,-)</b></div>
        <div class="wtr__switch__bottom" @click="setBelastingsPercentage(49.5)" :class="(belastingsPercentage === 49.5) ? 'wtr__switch--active':''"><b>49,50% (Belastbaar van € 69.399,- )</b></div>
    </div>
  </div>
  <div class="col-8 mt-3">
    <label for=""><b>Eigen bijdrage</b></label>
    <div class="searchbox">
      <div class="input-group stylish-input-group mt-2">
        <input type="number" class="form-control" name="eigenBijdrage" v-on:blur="setEigenBijdrage(eigenBijdrage)" v-model="eigenBijdrage">
      </div>
    </div>
  </div>
</div>
</template>
<script>

import vSelect from 'vue-select';
export default {
  components:{
    vSelect
  },
  mounted(){
    this.eigenBijdrage = this.nEigenBijdrage;
    this.belastingsPercentage = this.nBelastingsPercentage;
  },
  props: ['setEigenBijdrage', 'nEigenBijdrage', 'setBelastingsPercentage', 'nBelastingsPercentage'],
  data(){
    return {
      eigenBijdrage: 0,
      belastingsPercentage: 37.07,
      belastingsPercentageList: [{
        label:'37,07% (Belastbaar  tot € 69.398,-)',
        percentageLabel: '37,07%',
        percentage: 37.07
      },
      {
        label:'49,50% (Belastbaar van € 69.399,- )',
        percentageLabel: '49,50%',
        percentage: 49.5
      },
      ],
    }
  }
}

</script>
<style lang="scss" >
.wtr__switch--v{
  display: flex;
  flex-direction: column;
  width: 240px;
  background-color: white;

  .wtr__switch__top, .wtr__switch__bottom{
    width: 240px;
    padding: 12px;
    border: 1px solid #2ecc71;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .wtr__switch__top{
    border-radius: 8px 8px 0 0;
    border-bottom: 0px solid #2ecc71 !important;
  }
  .wtr__switch__bottom{
    border-radius: 0 0 8px 8px;
    border-top: 1px solid #2ecc71 !important;
  }
}
</style>